module.exports = __webpack_public_path__ + "img/about-us-home.3bf8ec42.png";